import { jsx as _jsx } from "react/jsx-runtime";
import { ShapeContainer } from './styles';
export function Shape({ shape, height, width, color }) {
    return _jsx(ShapeContainer, { shape: shape, height: height, width: width, color: color, "data-testid": "shape-container" });
}
//# sourceMappingURL=index.js.map